(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["glam-rental-collection"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-demo-rental-card]').forEach((card) => {
    const select = card.querySelector('[data-demo-rental-select]');
    const price = card.querySelector('[data-demo-price]');
    const tax = card.querySelector('[data-demo-tax]');
    const total = card.querySelector('[data-demo-total]');
    const deposit = card.querySelector('[data-demo-deposit]');
    if (!select || !price || !tax || !total) return;
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      price.textContent = `$${Number(option.value).toFixed(2).replace('.00', '')} rental`;
      tax.textContent = Number(option.dataset.tax).toFixed(2);
      total.textContent = Number(option.dataset.total).toFixed(2);
      if (deposit && option.dataset.deposit) deposit.textContent = Number(option.dataset.deposit).toFixed(2).replace('.00', '');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
